"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component = _interopRequireDefault(require("../../Component"));

var _main = _interopRequireDefault(require("../templates/main"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'checked').set;

if (!nativeInputValueSetter) {
  nativeInputValueSetter = function nativeInputValueSetter(value) {
    this.checked = value;
  };
}

var Main =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(Main, _View);

  function Main() {
    var _this;

    (0, _classCallCheck2["default"])(this, Main);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).call(this));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_createRef", function (el) {
      _this.nativeElement = el;

      if (typeof _this.props.elementRef === 'function') {
        _this.props.elementRef(el);
      }
    });
    _this.id = (0, _uniqueId["default"])('checkbox_');
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "value",
    get: function get() {
      return this.props.checked;
    },
    set: function set(checked) {
      nativeInputValueSetter.call(this.nativeElement, !!checked);
      this.nativeElement.dispatchEvent(new Event('click', {
        bubbles: true
      }));
    }
  }]);
  return Main;
}(_Component["default"]);

(0, _defineProperty2["default"])(Main, "propTypes", {
  icon: _propTypes["default"].any,
  checkedIcon: _propTypes["default"].any,
  label: _propTypes["default"].string,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default inline-block
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default palette.fontFamily
     */
    fontFamily: _propTypes["default"].string,

    /**
     * @default 1.5
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tLabel
     */
    color: _propTypes["default"].string,

    /**
     * @default 0
     */
    paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingBottom: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0 ${palette.gutter * 2}px 0 0
     */
    appearanceMargin: _propTypes["default"].string,

    /**
     * @default normal
     */
    wordWrap: _propTypes["default"].string,

    /**
     * @default normal
     */
    whiteSpace: _propTypes["default"].string,

    /**
     * @default #000
     */
    rippleColor: _propTypes["default"].string,

    /**
     * @default #000
     */
    iconColor: _propTypes["default"].string,

    /**
     * @default hidden
     */
    overflow: _propTypes["default"].string,

    /**
     * @default ellipsis
     */
    textOverflow: _propTypes["default"].string,

    /**
     * @default palette.tActive
     */
    checkedColor: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    checkedRippleColor: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    checkedIconColor: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    hoverColor: _propTypes["default"].string,

    /**
     * @default palette.tDisabled
     */
    disabledColor: _propTypes["default"].string,

    /**
     * @default palette.tError
     */
    errorColor: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'Checkbox');
var _default = Main;
exports["default"] = _default;